/**
 * Platform detection utilities
 *
 * Provides cross-platform detection for Windows, macOS, and mobile devices.
 */

/**
 * Detect if the current device is a mobile device (iOS, Android, or mobile browser)
 */
export function isMobileDevice(): boolean {
  if (typeof window === 'undefined') return false;

  const userAgent = window.navigator.userAgent.toLowerCase();

  // iOS detection (iPhone, iPad, iPod)
  const isIOS =
    /iphone|ipad|ipod/.test(userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1); // iPad Pro

  // Android detection
  const isAndroid = /android/.test(userAgent);

  // Additional mobile detection
  const isMobileUA = /mobile|tablet|phone|mobi/.test(userAgent);

  return isIOS || isAndroid || isMobileUA;
}

/**
 * Detect if the current platform is Windows
 */
export function isWindows(): boolean {
  if (typeof window === 'undefined') return false;
  const platform = navigator.platform?.toLowerCase() || '';
  const userAgent = navigator.userAgent?.toLowerCase() || '';
  return platform.includes('win') || userAgent.includes('windows');
}

/**
 * Detect if the current platform is macOS
 */
export function isMac(): boolean {
  if (typeof window === 'undefined') return false;
  const platform = navigator.platform?.toLowerCase() || '';
  const userAgent = navigator.userAgent?.toLowerCase() || '';
  return platform.includes('mac') || userAgent.includes('mac os x');
}

/**
 * Detect if the current platform is Linux
 */
export function isLinux(): boolean {
  if (typeof window === 'undefined') return false;
  const platform = navigator.platform?.toLowerCase() || '';
  const userAgent = navigator.userAgent?.toLowerCase() || '';
  return platform.includes('linux') || userAgent.includes('linux');
}
